// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"157":"d667a09d57d62a61","999":"8fd310b13eb9ee4e"}[chunkId] + ".js";
};